import { render, staticRenderFns } from "./CallsDaily.vue?vue&type=template&id=66c1d344"
import script from "./CallsDaily.vue?vue&type=script&lang=js"
export * from "./CallsDaily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports